<!-- The project colours to choose from (palette SERIES_COLORS), as round swatches: the chosen one has a ring. Used by
     Manage projects (#newProjectColors) and the first-project dialog (#firstProjectColors); the legacy projColorSwatches.
     Pass the container's id and layout with class ("flex flex-wrap gap-2"). -->
<script setup lang="ts">
import { SERIES_COLORS } from '../../utils/color'
import { useI18n } from '../../composables/useI18n'

defineProps<{ modelValue: string }>()
const emit = defineEmits<{ 'update:modelValue': [value: string] }>()
const { t } = useI18n()
</script>

<template>
  <div>
    <button v-for="c in SERIES_COLORS" :key="c" type="button" :title="t('Colour')"
      :class="['w-8 h-8 rounded-full transition', c === modelValue ? 'ring-2 ring-offset-2 ring-offset-darkcard ring-gray-100 scale-110' : 'hover:scale-110']"
      :style="{ background: c }" @click="emit('update:modelValue', c)"></button>
  </div>
</template>
